import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests'

export const mockGetApprovedExpenseItemCountSuccess = (count = 46) => {
  return http.get('/api/v3/expenses/items/approved/', ({ request }) => {
    // The count query requests page_size=1 — fall through to the list
    // handler for any other request against this endpoint
    if (new URL(request.url).searchParams.get('page_size') !== '1')
      return undefined

    return HttpResponse.json(getResponseObject([], { count }), { status: 200 })
  })
}
